import ActionTypes from '../actions/actionTypes';

const initialState = {
  isLoading: false,
  isLoaded: false,
  cards: [],
  isError: false,
  totalSize: 0,

  searchTerm: '',
  updatePinLoading: false,
  updatePinSuccess: false,
  updatePinFailure: false,

  resetPinIsLoading: false,
  resetPinIsError: false,
  resetPinSuccess: false,
  resetPinError: null,
  singleCardTransferLoading: false,
  singleCardTransferLoaded: null,
  singleCardTransferError: false,
  batchCardTransferLoading: false,
  batchCardTransferLoaded: null,
  batchCardTransferError: false,
  pendingCardsLoading: false,
  pendingCardsLoaded: false,
  pendingCardsError: false,
  pendingCards: [],
  pendingCardsSize: 0,

  createCardLoading: false,
  createCardLoaded: false,
  createCardError: false,
  createCardNumber: null,
  showCreatedCardModal: false,
  isCardNumberAdded: false,

  cancelPendingTransferBatchLoading: false,
  cancelPendingTransferBatchLoaded: false,
  cancelPendingTransferBatchError: false,

  updatePendingTransferBatchLoading: false,
  updatePendingTransferBatchLoaded: false,
  updatePendingTransferBatchError: false,

  downloadPendingTransfersLoading: false,
  downloadPendingTransfersLoaded: false,
  downloadPendingTransfersError: false,

  globalSearchLoading: false,
  globalSearchLoaded: false,
  globalSearchError: false,

  disableExpiryDate: false,
};

export function cardsReducer(state = initialState, { type, payload }) {
  let cards, totalSize;
  switch (type) {
    case ActionTypes.CARDS.UPDATE_CARD_MODAL_META:
      return {
        ...state,
        ...payload,
      };
    case ActionTypes.CARDS.UPDATE_SELECTED_CARD:
      return {
        ...state,
        ...payload,
      };
    case ActionTypes.CARDS.UPDATE_CARD_MODAL_FORM_VALUES:
      return {
        ...state,
        ...payload,
      };
    case ActionTypes.CARDS.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        isLoaded: false,
        cards: [],
      };
    case ActionTypes.CARDS.SUCCESS:
      cards = payload.result;
      totalSize = payload.resultSize;
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        cards,
        totalSize,
      };
    case ActionTypes.CARDS.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        cards: [],
        totalSize: 0,
      };
    case ActionTypes.CARDS.RESET:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isLoaded: false,
        cards: [],
        totalSize: 0,
      };
    case ActionTypes.CARDS.UPDATE.SEARCH_TERM:
      return {
        ...state,
        searchTerm: payload.searchTerm,
      };
    case ActionTypes.CARDS.UPDATE_PIN.REQUEST:
      return {
        ...state,
        updatePinLoading: true,
        updatePinSuccess: false,
        updatePinFailure: false,
      };
    case ActionTypes.CARDS.UPDATE_PIN.SUCCESS:
      return {
        ...state,
        updatePinLoading: false,
        updatePinSuccess: true,
        updatePinFailure: false,
      };
    case ActionTypes.CARDS.UPDATE_PIN.FAILURE:
      return {
        ...state,
        updatePinLoading: false,
        updatePinSuccess: false,
        updatePinFailure: true,
      };
    case ActionTypes.CARDS.UPDATE_PIN.RESET:
      return {
        ...state,
        isLoading: false,
        isError: false,
        updatePinSuccess: false,
        updatePinFailure: false,
      };
    case ActionTypes.CARDS.CREATE.REQUEST:
      return {
        ...state,
        createCardLoading: true,
        createCardError: false,
        createCardLoaded: false,
        createCardNumber: null,
      };
    case ActionTypes.CARDS.CREATE.SUCCESS:
      return {
        ...state,
        createCardLoading: false,
        createCardError: false,
        createCardLoaded: true,
        createCardNumber: payload?.cardNumber,
      };
    case ActionTypes.CARDS.CREATE.FAILURE:
      return {
        ...state,
        createCardLoading: false,
        createCardError: true,
        createCardLoaded: false,
      };
    case ActionTypes.CARDS.CREATE.RESET:
      return {
        ...state,
        createCardLoading: false,
        createCardError: false,
        createCardLoaded: false,
      };
    case ActionTypes.CARDS.CREATE.SHOW_MODAL:
      return {
        ...state,
        createCardLoaded: true,
        createCardNumber: payload?.cardNumber,
        showCreatedCardModal: true,
        isCardNumberAdded: true,
      };
    case ActionTypes.CARDS.CREATE.HIDE_MODAL:
      return {
        ...state,
        showCreatedCardModal: false,
      };
    case ActionTypes.CARDS.CREATE.RESET_ADD_CARD:
      return {
        ...state,
        isCardNumberAdded: false,
      };
    case ActionTypes.CARDS.RESET_PIN.REQUEST:
      return {
        ...state,
        resetPinIsLoading: true,
        resetPinIsError: false,
        resetPinSuccess: false,
      };
    case ActionTypes.CARDS.RESET_PIN.SUCCESS:
      return {
        ...state,
        resetPinIsLoading: false,
        resetPinIsError: false,
        resetPinSuccess: true,
      };
    case ActionTypes.CARDS.RESET_PIN.FAILURE:
      return {
        ...state,
        resetPinIsLoading: false,
        resetPinIsError: true,
        resetPinSuccess: false,
        resetPinError: payload,
      };
    case ActionTypes.CARDS.RESET_PIN.RESET:
      return {
        ...state,
        resetPinIsLoading: false,
        resetPinIsError: false,
        resetPinSuccess: false,
        resetPinError: null,
      };
    case ActionTypes.CARDS.TRANSFER_SINGLE.REQUEST:
      return {
        ...state,
        singleCardTransferLoading: true,
        singleCardTransferLoaded: false,
        singleCardTransferError: false,
      };
    case ActionTypes.CARDS.TRANSFER_SINGLE.SUCCESS:
      return {
        ...state,
        singleCardTransferLoading: false,
        singleCardTransferLoaded: true,
      };
    case ActionTypes.CARDS.TRANSFER_SINGLE.FAILURE:
      return {
        ...state,
        singleCardTransferLoading: false,
        singleCardTransferLoaded: false,
        singleCardTransferError: true,
      };
    case ActionTypes.CARDS.TRANSFER_SINGLE.RESET:
      return {
        ...state,
        singleCardTransferLoading: false,
        singleCardTransferLoaded: false,
        singleCardTransferError: false,
      };
    case ActionTypes.CARDS.TRANSFER_BATCH.REQUEST:
      return {
        ...state,
        batchCardTransferLoading: true,
        batchCardTransferLoaded: false,
        batchCardTransferError: false,
      };
    case ActionTypes.CARDS.TRANSFER_BATCH.SUCCESS:
      return {
        ...state,
        batchCardTransferLoading: false,
        batchCardTransferLoaded: true,
      };
    case ActionTypes.CARDS.TRANSFER_BATCH.FAILURE:
      return {
        ...state,
        batchCardTransferLoading: false,
        batchCardTransferLoaded: false,
        batchCardTransferError: true,
      };
    case ActionTypes.CARDS.TRANSFER_BATCH.RESET:
      return {
        ...state,
        batchCardTransferLoading: false,
        batchCardTransferLoaded: false,
        batchCardTransferError: null,
      };
    case ActionTypes.CARDS.PENDING.RESET:
      return {
        ...state,
        pendingCardsLoading: false,
        pendingCardsError: false,
        pendingCardsLoaded: false,
        pendingCards: [],
        pendingCardsSize: 0,
      };
    case ActionTypes.CARDS.PENDING.REQUEST:
      return {
        ...state,
        pendingCardsLoading: true,
        pendingCardsError: false,
      };
    case ActionTypes.CARDS.PENDING.SUCCESS:
      return {
        ...state,
        pendingCardsLoading: false,
        pendingCardsLoaded: true,
        pendingCards: payload.pendingCardsList,
        pendingCardsSize: payload.pendingCardsSize,
      };
    case ActionTypes.CARDS.PENDING.FAILURE:
      return {
        ...state,
        pendingCardsLoading: false,
        pendingCardsError: true,
        pendingCards: [],
        pendingCardsSize: 0,
      };
    case ActionTypes.CARDS.CANCEL_PENDING_TRANSFER_BATCH.REQUEST:
      return {
        ...state,
        cancelPendingTransferBatchLoading: true,
        cancelPendingTransferBatchLoaded: false,
        cancelPendingTransferBatchError: false,
      };
    case ActionTypes.CARDS.CANCEL_PENDING_TRANSFER_BATCH.SUCCESS:
      return {
        ...state,
        cancelPendingTransferBatchLoading: false,
        cancelPendingTransferBatchLoaded: true,
      };
    case ActionTypes.CARDS.CANCEL_PENDING_TRANSFER_BATCH.FAILURE:
      return {
        ...state,
        cancelPendingTransferBatchLoading: false,
        cancelPendingTransferBatchError: true,
      };
    case ActionTypes.CARDS.UPDATE_PENDING_TRANSFER_BATCH.REQUEST:
      return {
        ...state,
        updatePendingTransferBatchLoading: true,
        updatePendingTransferBatchLoaded: false,
        updatePendingTransferBatchError: false,
      };
    case ActionTypes.CARDS.UPDATE_PENDING_TRANSFER_BATCH.SUCCESS:
      return {
        ...state,
        updatePendingTransferBatchLoading: false,
        updatePendingTransferBatchLoaded: true,
      };
    case ActionTypes.CARDS.UPDATE_PENDING_TRANSFER_BATCH.FAILURE:
      return {
        ...state,
        updatePendingTransferBatchLoading: false,
        updatePendingTransferBatchError: true,
      };
    case ActionTypes.CARDS.PENDING_TRANSFERS_DOWNLOAD.REQUEST:
      return {
        ...state,
        downloadPendingTransfersLoading: true,
        downloadPendingTransfersLoaded: false,
        downloadPendingTransfersError: false,
      };
    case ActionTypes.CARDS.PENDING_TRANSFERS_DOWNLOAD.SUCCESS:
      return {
        ...state,
        downloadPendingTransfersLoading: false,
        downloadPendingTransfersLoaded: true,
      };
    case ActionTypes.CARDS.PENDING_TRANSFERS_DOWNLOAD.FAILURE:
      return {
        ...state,
        downloadPendingTransfersLoading: false,
        downloadPendingTransfersError: true,
      };
    case ActionTypes.CARDS.GLOBAL_SEARCH.REQUEST:
      return {
        ...state,
        globalSearchLoading: true,
        globalSearchLoaded: false,
        globalSearchError: false,
        globalSearchResult: null,
      };
    case ActionTypes.CARDS.GLOBAL_SEARCH.SUCCESS:
      if (payload?.resultType === 'Card') {
        return {
          ...state,
          globalSearchLoading: false,
          globalSearchLoaded: true,
          globalSearchResult: payload.result && payload.result?.[0]?.cardNumber,
          globalSearchType: 'Card',

          totalSize: payload.result ? payload.result.length : state.totalSize,
          cards: payload.result || state.cards,
        };
      } else if (payload.resultType === 'Registration') {
        return {
          ...state,
          globalSearchLoading: false,
          globalSearchLoaded: true,
          globalSearchResult: payload.result && payload.result?.[0]?.registrationNumber,
          globalSearchType: 'Registration',

          totalSize: payload.result ? payload.result.length : state.totalSize,
          cards: payload.result || state.cards,
        };
      } else if (payload.resultType === 'Cash') {
        return {
          ...state,
          globalSearchLoading: false,
          globalSearchLoaded: true,
          globalSearchResult: payload?.card && payload?.card?.cardNumber,
          globalSearchType: 'Cash',

          totalSize: payload.order ? payload.order.resultSize : state.totalSize,
          // passing in data for Cash Details
          cashOrdersList: payload?.orders?.result || state?.orders?.result,
          cashOrdersListResultSize: payload?.orders?.resultSize || state?.orders?.resultSize,
          cashOrderCardDetails: payload?.card,
        };
      }
      break;
    case ActionTypes.CARDS.GLOBAL_SEARCH.FAILURE:
      return {
        ...state,
        globalSearchLoading: false,
        globalSearchError: true,
      };
    case ActionTypes.CARDS.GLOBAL_SEARCH.RESET:
      return {
        ...state,
        globalSearchLoading: false,
        globalSearchLoaded: false,
        globalSearchError: false,
      };
    case ActionTypes.CARDS.DISABLE_EXPIRY_DATE: 
      return {
        ...state,
        disableExpiryDate: payload.disableExpiryDate,
      };
    default:
      return state;
  }
}

const initialStateCardDetail = {
  isLoading: false,
  cardDetail: null,
  isError: false,
  success: false,

  editCardLoading: false,
  editCardLoaded: false,
  editCardError: false,
  isPreviousOrReplacementCardClicked: false,
  previousOrReplacementCardNumber: null,
  isResetSelectedContent: false, // If a previous, replacement card or back button is clicked, reset selected content to Card History
};

export function cardDetailReducer(state = initialStateCardDetail, action) {
  switch (action.type) {
    case ActionTypes.CARDS.DETAIL.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        cardDetail: {},
        isPreviousOrReplacementCardClicked: action?.payload?.isPreviousOrReplacementCardClicked,
        previousOrReplacementCardNumber: action?.payload?.isPreviousOrReplacementCardClicked
          ? (state.previousOrReplacementCardNumber ?? state?.cardDetail?.cardNumber)
          : null,
        isResetSelectedContent: state.previousOrReplacementCardNumber === action?.payload?.cardNumber,
      };
    case ActionTypes.CARDS.DETAIL.SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        cardDetail: {
          ...action.payload.details,
          services: action.payload.details.fleetLimiters,
        },
      };
    case ActionTypes.CARDS.DETAIL.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    case ActionTypes.CARDS.DETAIL.RESET:
      return {
        ...state,
        isLoading: false,
        isError: false,
        success: false,
        cardDetail: {},
        isPreviousOrReplacementCardClicked: false,
        previousOrReplacementCardNumber: null,
        isResetSelectedContent: false,
      };
    case ActionTypes.CARDS.EDIT.REQUEST:
      return {
        ...state,
        editCardLoading: true,
        editCardError: false,
        editCardLoaded: false,
      };
    case ActionTypes.CARDS.EDIT.SUCCESS:
      return {
        ...state,
        editCardLoading: false,
        editCardLoaded: true,
        editCardError: false,
        cardDetail: action.payload.details,
      };
    case ActionTypes.CARDS.EDIT.FAILURE:
      return {
        ...state,
        editCardLoading: false,
        editCardError: true,
        editCardLoaded: false,
      };
    case ActionTypes.CARDS.EDIT.RESET:
      return {
        ...state,
        editCardLoading: false,
        editCardError: false,
        editCardLoaded: false,
      };
    default:
      return state;
  }
}

const initialStateActivateCards = {
  isLoading: false,
  isError: false,
  activateCardSuccess: false,
};

export function activateCardReducer(state = initialStateActivateCards, { type }) {
  switch (type) {
    case ActionTypes.CARDS.ACTIVATE.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        activateCardSuccess: false,
      };
    case ActionTypes.CARDS.ACTIVATE.SUCCESS:
      return {
        ...state,
        isLoading: false,
        activateCardSuccess: true,
        isError: false,
      };
    case ActionTypes.CARDS.ACTIVATE.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        activateCardSuccess: false,
      };
    case ActionTypes.CARDS.ACTIVATE.RESET:
      return {
        ...state,
        isLoading: false,
        isError: false,
        activateCardSuccess: false,
      };
    default:
      return state;
  }
}

export function activateMultipleCardsReducer(state = initialStateActivateCards, { type }) {
  switch (type) {
    case ActionTypes.CARDS.ACTIVATE_MULTIPLE.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        activateCardSuccess: false,
      };
    case ActionTypes.CARDS.ACTIVATE_MULTIPLE.SUCCESS:
      return {
        ...state,
        isLoading: false,
        activateCardSuccess: true,
        isError: false,
      };
    case ActionTypes.CARDS.ACTIVATE_MULTIPLE.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        activateCardSuccess: false,
      };
    case ActionTypes.CARDS.ACTIVATE_MULTIPLE.RESET:
      return {
        ...state,
        isLoading: false,
        isError: false,
        activateCardSuccess: false,
      };
    default:
      return state;
  }
}

const initialStateCardStatus = {
  isLoading: false,
  isError: false,
  success: false,
};

export function setCardStatusReducer(state = initialStateCardStatus, { type }) {
  switch (type) {
    case ActionTypes.CARDS.STATUS.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        success: false,
      };
    case ActionTypes.CARDS.STATUS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        isError: false,
      };
    case ActionTypes.CARDS.STATUS.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        success: false,
      };
    case ActionTypes.CARDS.STATUS.RESET:
      return {
        ...state,
        ...initialStateCardStatus,
      };
    default:
      return state;
  }
}

export function setMultipleCardStatusReducer(state = initialStateCardStatus, { type }) {
  switch (type) {
    case ActionTypes.CARDS.MULTIPLE_CARDS_STATUS.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        success: false,
      };
    case ActionTypes.CARDS.MULTIPLE_CARDS_STATUS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        isError: false,
      };
    case ActionTypes.CARDS.MULTIPLE_CARDS_STATUS.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        success: false,
      };
    case ActionTypes.CARDS.MULTIPLE_CARDS_STATUS.RESET:
      return {
        ...state,
        ...initialStateCardStatus,
      };
    default:
      return state;
  }
}

export function setCardUsageOptionsReducer(
  state = {
    isLoading: false,
    isError: false,
    setCardUsageOptionsSuccess: false,
  },
  { type }
) {
  switch (type) {
    case ActionTypes.CARDS.CARD_OPTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        setCardUsageOptionsSuccess: false,
      };
    case ActionTypes.CARDS.CARD_OPTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        setCardUsageOptionsSuccess: true,
        isError: false,
      };
    case ActionTypes.CARDS.CARD_OPTIONS.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        setCardUsageOptionsSuccess: false,
      };
    case ActionTypes.CARDS.CARD_OPTIONS.RESET:
      return {
        ...state,
        isLoading: false,
        isError: false,
        setCardUsageOptionsSuccess: false,
      };
    default:
      return state;
  }
}

const initialStateUpdateCard = {
  isLoading: false,
  isError: false,
  success: false,
};

export function editMultipleCardDetailReducer(state = initialStateUpdateCard, { type }) {
  switch (type) {
    case ActionTypes.CARDS.UPDATE_MULTIPLE.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
        success: false,
      };
    case ActionTypes.CARDS.UPDATE_MULTIPLE.SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        isError: false,
      };
    case ActionTypes.CARDS.UPDATE_MULTIPLE.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        success: false,
      };
    case ActionTypes.CARDS.UPDATE_MULTIPLE.RESET:
      return {
        ...state,
        isLoading: false,
        isError: false,
        success: false,
      };

    default:
      return state;
  }
}

const initialStateCardAccountDefault = {
  isLoading: false,
  isError: false,
  result: {},
};

export function getCardAccountDefaultReducer(state = initialStateCardAccountDefault, { type, payload }) {
  let result;

  switch (type) {
    case ActionTypes.CARDS.ACCOUNT_DEFAULT.REQUEST:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case ActionTypes.CARDS.ACCOUNT_DEFAULT.SUCCESS:
      result = payload;
      return {
        ...state,
        isLoading: false,
        result,
      };
    case ActionTypes.CARDS.ACCOUNT_DEFAULT.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    case ActionTypes.CARDS.ACCOUNT_DEFAULT_RESET.REQUEST:
      return {
        ...state,
        isLoading: false,
        isError: false,
        result: {},
      };
    default:
      return state;
  }
}
